import React, { PureComponent } from 'react';
import AvailableProducts from './AvailableProducts.js';
import PurchasedProducts from './PurchasedProducts.js';
import TransactionHistory from './TransactionHistory.js';
class Dashboard extends PureComponent {
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AvailableProducts, {
      isMasterSite: this.props.isMasterSite,
      hasBanking: this.props.hasBanking,
      whitelabel: this.props.whitelabel,
      member: this.props.member,
      purchasedProducts: this.props.purchasedProducts,
      availableProducts: this.props.availableProducts,
      coverageBlocks: this.props.coverageBlocks,
      selectProduct: this.props.selectProduct,
      loading: this.props.loading
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        height: 30
      }
    }), /*#__PURE__*/React.createElement(PurchasedProducts, {
      isMasterSite: this.props.isMasterSite,
      whitelabel: this.props.whitelabel,
      member: this.props.member,
      purchasedProducts: this.props.purchasedProducts,
      selectProduct: this.props.selectProduct,
      terminateProduct: this.props.terminateProduct,
      loading: this.props.loading
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        height: 20
      }
    }), /*#__PURE__*/React.createElement(TransactionHistory, {
      isMasterSite: this.props.isMasterSite,
      whitelabel: this.props.whitelabel,
      invoices: this.props.invoices,
      getInvoice: this.props.getInvoice,
      loading: this.props.loading,
      showingHistoryDefault: false,
      downloadPDFToBrowser: this.props.downloadPDFToBrowser,
      applyCarryForwardBalance: this.props.isMasterSite ? this.props.applyCarryForwardBalance : null,
      dispatch: this.props.dispatch,
      userID: this.props.userID
    }));
  }
}
export default Dashboard;